module.exports = __webpack_public_path__ + "templates.store_pick_up_options-a5fe6af2.html";